import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private http = inject(HttpClient);
  private permissionCache = new Map<string, Observable<boolean>>();

  private getPermission$(actionKey: string): Observable<boolean> {

    if (this.permissionCache.has(actionKey)) {
      return this.permissionCache.get(actionKey)!;
    }

    const permission$ = this.http.post<Record<string, boolean>>(
      `${environment.resourceManagerUrl}/check`,
      { actionsKeys: [actionKey] }
    ).pipe(
      map(response => response?.toString() === 'true'),
      shareReplay(1)
    );

    this.permissionCache.set(actionKey, permission$);
    return permission$;
  }

  get can_read_service_config$(): Observable<boolean> {
    return this.getPermission$('gsa_api_pager-service_configuration_read');
  }

  get can_write_service_config$(): Observable<boolean> {
    return this.getPermission$('gsa_api_pager-service_configuration_write');
  }
}
